<dhhp-profile-details [isDisableSetting]="true" [role]="config?.userData?.roleName?.roleName" [userData]="config?.userData"
    [institutionname]="packageInstitutionsList" [userprinciplename]="userprinciplename" [logOutUrl]="logOutUrl"
    (dataEvent)="onDataEvent($event)"></dhhp-profile-details>